<template>
  <div class="subscConfirm">
    <app-loading class="loading" :isLoading="isLoading"></app-loading>
    <p v-if="!isRejoin" class="subscConfirm__step">ステップ2/2</p>
    <h1 class="subscConfirm__title">お支払い情報を登録</h1>
    <Attention v-if="error" :text="error"/>
    <SubscDescription 
      :subsc-price="Number(item.priceTaxin)"
      :is-rejoin="isRejoin"
      :is-subsc-trial="isSubscTrial"
      :payment-method="payment.method"
    />
    <div class="subscConfirm__foot">
      <form ref="form" :action="action" method="POST" @submit.prevent>
        <input type="hidden" name="_token" :value="form.token">
        <input type="hidden" name="amazonCheckoutSessionId" :value="form.sessionId" />
        <input type="hidden" name="amzpPrefixCode" :value="form.amzp_prefix_code" />
        <input type="hidden" name="return" value="1">
        <input
          v-for="(value, name) in form.params"
          :key="name"
          type="hidden"
          :name="name"
          :value="value"
        />
        <BaseButton
          v-if="!isRejoin"
          class="subscConfirm__modify" 
          :is-disabled="isLoading"
          label="修正"
          @clicked="modify"
        />
        <BaseButton
          v-if="!error"
          class="subscConfirm__button" 
          :design="isRejoin ? '' : 'fill'"
          :is-disabled="isLoading"
          :label="`サブスクリプションを${isRejoin ? '再開' : '開始'}する`"
          @clicked="submit"
        />
      </form>
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex'
import Attention from './common/Attention'
import BaseButton from './common/BaseButton'
import SubscDescription from './SubscDescription'

export default {
  name: 'SubscConfirm',
  components:{
    Attention,
    BaseButton,
    SubscDescription,
  },
  data() {
    return {
      action: '',
      isLoading: false,
      // サブスクの再開かどうか
      isRejoin: false,
    }
  },
  computed: {
    ...mapState({
      subscInfo: state => state.account.subscription
    }),
  },
  props: {
    error: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    payment: {
      type: Object,
      default() {
        return {}
      },
    },
    form: {
      type: Object,
      default() {
        return {}
      }
    },
    token: {
      type:String,
      default:''
    },
    subscPrice: {
      type: Number,
      default:0
    },
    // サブスクのお試し2週間無料が有効か
    isSubscTrial: {
      type: Number,
      default: 1,
    },
    // お支払い方法
    paymentMethod: {
      type: String,
      default: '',
    },
  },
  created() {
    if (this.subscInfo.status == 2) this.isRejoin = true
  },
  methods: {
    modify() {
      this.isLoading = true
      this.action = this.form.cancel
      this.$nextTick(() => {
        this.$refs.form.submit()
      })
    },
    submit() {
      this.isLoading = true
      this.action = this.form.checkout
      this.$nextTick(() => {
        this.$refs.form.submit()
      })
    },
  }
}</script>

<style lang="scss" scoped>
@import "../../../sass/commons/commonVariables.scss";
.subscConfirm{
  color: $col_base_black;
  padding: 38px 30px 40px;
  max-width: 580px;
  margin: auto;

  &__step{
    font-weight: bold;
    font-size: 11px;
    text-align: center;
    margin: 0;
    &::after {
      content: '';
      display: block;
      width: 15px;
      height: 2px;
      margin: 5px auto 0;
      background: linear-gradient(65.54deg, $col_temp_key1 21.4%, $col_temp_key2 76.64%);
    }
  }

  &__title{
    font-size: 21px;
    line-height: 31px;
    text-align: center;
    margin: 2px 0 40px;
  }

  &__foot {
    margin: 30px 0;
  }
  &__modify {
    margin-bottom: 20px;
  }
}

.loading {
  position: absolute;
  z-index: 3;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>

<style lang="scss">
.subscConfirm .baseButton__button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/SubscConfirm.vue